import Footer from 'components/Footer'
import UserNavbar from 'components/navbar/UserNavbar'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { selectFullScreenMode } from 'routing/fetchingfunction/user/user.reducer'

// import Navbar from '../navbar'
// import Footer from '../Footer'
// import Navbar from 'components/navbar'
// import Navbar from 'components/navbar'
// import Navbar from 'components/navbar'

const UserLayout = () => {
  const fullscreen = useSelector(selectFullScreenMode)
  return (
    <>
      {!fullscreen && <UserNavbar />}
      <Outlet />
      {/* <Footer /> */}
    </>
  )
}

export default UserLayout
